<div class="manage-address-main">
  <div class="manage-main" (click)="$event.stopPropagation()">
    <ng-container *ngIf="!showAddressForm">
      <div class="manage-address-child">
        <div class="manage-address-top">
          <h2>Address</h2>
          <button class="close-btn" (click)="onHideShowPopup()" mat-dialog-close>
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <!-- END! manage-address-top -->
        <div class="user-address-main">
          <div
            class="user-present-address"
            *ngFor="let data of addresses"
            style="cursor: pointer"
            [class]="data?._id === isSelectedAddressId ? 'active' : ''"
            (click)="onSelectAddress(data)"
          >
            <div class="user-address-child">
              <p>Name: {{ data?.name | titlecase }}</p>
              <div class="three-dot">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="Example icon-button with a menu"
                  (click)="$event.stopPropagation()"
                  type="button"
                >
                  <svg
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                    ></path>
                  </svg>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    type="button"
                    (click)="onSelectEdittedAddress(data)"
                  >
                    <span>Edit</span>
                  </button>
                  <button
                    mat-menu-item
                    type="button"
                    (click)="deleteAddressById(data?._id)"
                  >
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </div>
            </div>

            <div class="user-address-child">
              <p>Phone: {{ data?.phone }}</p>
            </div>

            <div class="user-address-child">
              <p>Address:{{ data?.address }}</p>
            </div>

            <div class="user-address-child">
              <h3>
                Address Type: <span>{{ data?.addressType | titlecase }}</span>
              </h3>
            </div>
          </div>
          <!-- END! user-present-address -->

          <div class="user-address-update" (click)="onShowAddressForm()">
            <i class="fa-solid fa-plus"></i>
            <p>{{ "Add new address" | titlecase }}</p>
          </div>
          <!-- END! user-address-update -->
        </div>
      </div>
      <!-- END! manage-address-child -->
    </ng-container>
    <ng-container *ngIf="showAddressForm">
      <div class="get-address">
        <div class="manage-address-top">
          <h2>Add Shipping Address</h2>
          <button class="close-btn" (click)="onHideShowPopup()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <!-- END! manage-address-top -->

        <form (ngSubmit)="onFormSubmit()" [formGroup]="dataForm">
          <div class="form-all-input">
            <div class="form-input-select">
              <mat-form-field class="mat-input-field" appearance="outline">
                <mat-label>Full Name</mat-label>
                <input
                  matInput
                  formControlName="name"
                  placeholder="Enter your name"
                />
                <mat-error>This field is required</mat-error>
              </mat-form-field>
            </div>

            <div class="form-input-select">
              <mat-form-field class="mat-input-field" appearance="outline">
                <mat-label>Mobile Number</mat-label>
                <input
                  matInput
                  formControlName="phone"
                  placeholder="Enter mobile number"
                />
                <mat-error>This field is required</mat-error>
              </mat-form-field>
            </div>

            <div class="form-input-select">
              <div class="form-input-area">
                <div class="country">
                  <app-general-dropdown
                    [inputData]="divisions"
                    [placeHolderId]="dataForm.value?.division"
                    [label]="'Division'"
                    (passDataEvent)="onChangeRegion($event)"
                  ></app-general-dropdown>
                </div>
              </div>
            </div>

            <div class="form-input-select">
              <div class="form-input-area">
                <div class="country">
                  <app-general-dropdown
                    [inputData]="area"
                    [placeHolderId]="dataForm.value?.area"
                    [label]="'District'"
                    (passDataEvent)="onChangeArea($event)"
                  ></app-general-dropdown>
                </div>
              </div>
            </div>
            <div class="form-input-select">
              <div class="form-input-area">
                <div class="country">
                  <app-general-dropdown
                    [inputData]="zone"
                    [placeHolderId]="dataForm.value?.zone"
                    [label]="'Upozila/Thana'"
                    (passDataEvent)="onChangeZone($event)"
                  ></app-general-dropdown>
                </div>
              </div>
            </div>

            <div class="form-input-select">
              <mat-form-field class="mat-input-field" appearance="outline">
                <mat-label>Address</mat-label>
                <input
                  matInput
                  formControlName="address"
                  placeholder="Enter your name"
                />
                <mat-error>This field is required</mat-error>
              </mat-form-field>
            </div>

            <div class="address-select">
              <p>Address Type</p>

              <div class="address-bar">
                <button
                  type="button"
                  [class.active]="storeAddress === 'home'"
                  (click)="onAddressSelect('home')"
                >
                  <svg
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path>
                  </svg>
                  <span> Home </span>
                </button>
                <button
                  type="button"
                  [class.active]="storeAddress === 'office'"
                  (click)="onAddressSelect('office')"
                >
                  <svg
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      d="M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
                    ></path>
                  </svg>
                  <span>Office</span>
                </button>
                <button
                  type="button"
                  [class.active]="storeAddress === 'home town'"
                  (click)="onAddressSelect('home town')"
                >
                  <svg
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M8.17 5.7L1 10.48V21h5v-8h4v8h5V10.25z"></path>
                    <path
                      d="M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
                    ></path>
                  </svg>
                  <span>Home Town</span>
                </button>
              </div>
            </div>
          </div>
          <!-- END! form-all-input -->

          <div class="submit-and-slider">
            <div style="visibility: hidden">g</div>

            <button class="submit-btn" type="submit" *ngIf="isSelect === false">
              {{ isLoading ? "Please wait.." : "Save Address" }}
            </button>

            <button class="submit-btn" type="submit" *ngIf="isSelect === true">
              {{ isLoading ? "Please wait.." : "Update Address" }}
            </button>
          </div>
          <!-- END! submit-and-slider -->
        </form>
        <!-- END! form -->
      </div>
      <!-- END! get-address -->
    </ng-container>
  </div>
</div>
<!-- END! manage-address-main -->
